// Make embedded iframes fill the reading column.
//
// Ghost stores the HTML that oEmbed providers return, and most of them
// hard-code small width/height attributes on the iframe. YouTube and Vimeo
// are handled in CSS; this covers everything else that gives us numeric
// dimensions, keeping the provider's aspect ratio. Iframes with a
// percentage width (Spotify, for instance) are already fluid and are left
// alone, as are portrait players (a tall Bandcamp widget, say), which are
// designed for their stated size and only get worse when enlarged.
export default function embeds() {
    const frames = document.querySelectorAll(".kg-embed-card iframe[width][height]");

    frames.forEach((frame) => {
        const w = parseFloat(frame.getAttribute("width"));
        const h = parseFloat(frame.getAttribute("height"));
        const widthAttr = frame.getAttribute("width") || "";

        if (!w || !h || widthAttr.includes("%") || w <= h) return;

        frame.style.setProperty("--embed-ratio", `${w} / ${h}`);
        frame.setAttribute("data-fluid", "");
    });
}
